import styled from '@emotion/styled'
import { Tooltip } from 'components/Tooltip'
import { BREAKPOINTS } from 'utils/styled'

export const STrustWillPerksSection = styled.div`
  display: grid;

  align-items: center;

  grid-template-columns: 1fr;
  grid-auto-flow: row;
  grid-gap: 1.5rem;

  @media ${BREAKPOINTS.MD.min} {
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
    grid-auto-flow: dense;
  }
  @media ${BREAKPOINTS.LG.min} {
    grid-gap: 10rem;
  }
`

export const SLeftColumn = styled.div`
  grid-row-start: 2;
  @media ${BREAKPOINTS.MD.min} {
    grid-row-start: 1;
  }
`
export const SRightColumn = styled.div`
  grid-row-start: 1;
`

export const SPerkGrid = styled.div`
  grid-auto-flow: column;
  display: grid;
  grid-template-rows: repeat(6, 1fr);
  grid-column-gap: 0.5rem;
  grid-row-gap: 1rem;
  @media ${BREAKPOINTS.SM.min} {
    grid-template-rows: repeat(3, 1fr);
  }
`

export const SButtonWrapper = styled.div`
  @media ${BREAKPOINTS.MD.min} {
    align-self: start;
  }
`

export const STooltip = styled(Tooltip)<{ orientation: 'left' | 'right' }>`
  display: none;
  min-width: 13rem;
  z-index: 1;
  right: 0.5rem;
  ${({ orientation }) => (orientation === 'left' ? 'left: 0.5rem; right: unset;' : '')}
  @media ${BREAKPOINTS.MD.min} {
    min-width: 20rem;
  }
`

export const SIconWrapper = styled.div`
  position: relative;
  &:hover > span {
    display: block;
  }
`
